// extracted by mini-css-extract-plugin
export default {"infoStrip":"infoStrip_infoStrip__afvVN","rectangleIcon":"infoStrip_rectangleIcon__N+86Q","closeButton":"infoStrip_closeButton__yS-bZ","closeIcon":"infoStrip_closeIcon__kQ1+L"};